// Tiny i18n. EN + TH only. Returns a function `t(key)` for inline strings
// and `pickLocalized(translations, locale)` for service/extras translations
// stored as { en, th } on the server side.

const STRINGS = {
  en: {
    'steps.service': 'Service',
    'steps.time': 'Time',
    'steps.details': 'Your details',
    'steps.pay': 'Pay',
    'service.heading': 'Choose a service',
    'service.empty': 'No services available.',
    'service.duration': '{n} min',
    'staff.heading': 'Choose your therapist',
    'staff.any': 'Best available',
    'slot.heading': 'Choose a time',
    'slot.empty': 'No slots available on this day.',
    'slot.loading': 'Loading availability…',
    'extras.heading': 'Add extras',
    'extras.skip': 'Skip',
    'details.heading': 'Your details',
    'details.name': 'Full name',
    'details.email': 'Email',
    'details.phone': 'Phone (optional)',
    'details.notes': 'Notes (optional)',
    'details.continue': 'Continue to payment',
    'pay.heading': 'Payment',
    'pay.total': 'Total',
    'pay.cta': 'Pay now',
    'pay.processing': 'Processing…',
    'pay.failed': 'Payment failed. Please try again.',
    'pay.confirming': 'Confirming your booking…',
    'pay.processingMessage': 'Your payment is processing. We will confirm the reservation as soon as the provider finishes.',
    'pay.cancelAndChoose': 'Cancel and choose another time',
    'pay.cancelAndChangeMethod': 'Cancel payment and change method',
    'pay.cancelProcessing': 'PromptPay is already active and cannot be changed safely. Complete this payment or wait for the QR code to expire.',
    'pay.timeRemaining': 'Time remaining: {time}',
    'pay.expiredMessage': 'Reservation expired. Please pick a new time.',
    'pay.expiredButton': 'Pick new time',
    'pay.secureHandoff': 'Continue to secure payment',
    'pay.secureHandoffBody': 'Opening the secure SanookPass payment page…',
    'pay.secureHandoffButton': 'Continue to payment',
    'pay.secureLabel': 'Secure payment',
    'pay.secureBy': 'Encrypted and processed by',
    'pay.secureByOmise': 'Encrypted and processed by Omise',
    'pay.omiseFrameDescription': 'Secure payment for your SanookPass booking',
    'pay.promptPayTitle': 'Scan to pay with PromptPay',
    'pay.promptPayInstructions': 'Open your banking app and scan this QR code. Keep this page open while we confirm your payment.',
    'pay.promptPayQrAlt': 'PromptPay payment QR code',
    'pay.promptPayWaiting': 'Waiting for payment confirmation…',
    'pay.promptPayTimeRemaining': 'PromptPay QR expires in {time}',
    'pay.promptPayExpired': 'PromptPay QR expired. Reloading payment methods…',
    'pay.paymentMethods': 'Supported payment methods',
    'pay.methodAvailability': 'Available methods depend on your device and card.',
    'pay.loadingMethods': 'Loading secure payment methods…',
    'pay.notReady': 'The secure payment form is still loading. Please wait a moment.',
    'pay.loadFailed': 'The secure payment form could not load. Please refresh and try again.',
    'pay.sessionMissing': 'Your secure payment session is unavailable. Reload it to continue.',
    'pay.configurationMissing': 'The merchant payment configuration is incomplete. Reload the secure payment details.',
    'pay.reload': 'Reload secure payment',
    'done.heading': 'You are booked!',
    'done.summary': 'Booking #{id}',
    'done.backupCode': 'Your backup code',
    'done.backupCodeHint': 'Keep this code in case you cannot find your confirmation email.',
    'done.cancel': 'Need to cancel?',
    'done.calendar': 'Add to calendar',
    'reservation.heading': 'Your saved reservation',
    'reservation.summary': 'Confirmation code: {code}',
    'reservation.view': 'View reservation',
    'reservation.pending': 'Payment is still needed to hold this appointment.',
    'reservation.completePayment': 'Complete payment',
    'reservation.processing': 'Payment is processing',
    'reservation.expired': 'This reservation has expired.',
    'reservation.chooseAnother': 'Choose another time',
    'error.merchantPayments': 'This merchant has not finished linking online payments.',
    'error.paymentsUnavailable': 'Online payments are temporarily unavailable. Please try again.',
    'error.slotTaken': 'That time was just taken. Please choose another slot.',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.cancel': 'Cancel',
    'common.loading': 'Loading…',
    'common.error': 'Something went wrong. Please try again.',
    'common.required': 'Required',
    'policy.heading': 'Cancellation policy',
    'footer.poweredBy': 'Powered by',
    'footer.cancellationPolicy': 'Cancellation policy',
    'footer.contact': 'Contact',
    'footer.brand': 'SanookPass',
    'header.locale.en': 'EN',
    'header.locale.th': 'TH',
    'refund.heading': 'Cancellation policy',
    'refund.loading': 'Loading policy…',
    'refund.failed': 'Could not load the cancellation policy.',
    'refund.close': 'Close',
    'contact.heading': 'Contact {shop}',
    'contact.address': 'Address',
    'contact.phone': 'Phone',
    'contact.email': 'Email',
    'contact.loading': 'Loading contact…',
    'contact.failed': 'Could not load contact information.',
    'contact.close': 'Close',
  },
  th: {
    'steps.service': 'บริการ',
    'steps.time': 'เวลา',
    'steps.details': 'ข้อมูลส่วนตัว',
    'steps.pay': 'ชำระเงิน',
    'service.heading': 'เลือกบริการ',
    'service.empty': 'ขณะนี้ยังไม่มีบริการ',
    'service.duration': '{n} นาที',
    'staff.heading': 'เลือกผู้ให้บริการ',
    'staff.any': 'ผู้ให้บริการที่เหมาะสมและว่าง',
    'slot.heading': 'เลือกเวลานัดหมาย',
    'slot.empty': 'วันนี้ไม่มีช่วงเวลาว่าง',
    'slot.loading': 'กำลังโหลดช่วงเวลาว่าง…',
    'extras.heading': 'เพิ่มบริการเสริม',
    'extras.skip': 'ข้าม',
    'details.heading': 'ข้อมูลส่วนตัว',
    'details.name': 'ชื่อ-นามสกุล',
    'details.email': 'อีเมล',
    'details.phone': 'เบอร์โทรศัพท์ (ไม่บังคับ)',
    'details.notes': 'หมายเหตุ (ไม่บังคับ)',
    'details.continue': 'ดำเนินการชำระเงิน',
    'pay.heading': 'ชำระเงิน',
    'pay.total': 'ยอดรวม',
    'pay.cta': 'ชำระเงินตอนนี้',
    'pay.processing': 'กำลังดำเนินการ…',
    'pay.failed': 'ชำระเงินไม่สำเร็จ โปรดลองอีกครั้ง',
    'pay.confirming': 'กำลังยืนยันการจองของคุณ…',
    'pay.processingMessage': 'การชำระเงินกำลังดำเนินการ เราจะยืนยันการจองทันทีเมื่อผู้ให้บริการดำเนินการเสร็จสิ้น',
    'pay.cancelAndChoose': 'ยกเลิกและเลือกเวลาอื่น',
    'pay.cancelAndChangeMethod': 'ยกเลิกการชำระเงินและเปลี่ยนวิธีชำระ',
    'pay.cancelProcessing': 'PromptPay เริ่มดำเนินการแล้วและไม่สามารถเปลี่ยนได้อย่างปลอดภัย โปรดชำระเงินให้เสร็จหรือรอให้คิวอาร์โค้ดหมดอายุ',
    'pay.timeRemaining': 'เวลาที่เหลือ: {time}',
    'pay.expiredMessage': 'หมดเวลาการจองแล้ว โปรดเลือกเวลาใหม่',
    'pay.expiredButton': 'เลือกเวลาใหม่',
    'pay.secureHandoff': 'ดำเนินการชำระเงินอย่างปลอดภัย',
    'pay.secureHandoffBody': 'กำลังเปิดหน้าชำระเงินที่ปลอดภัยของ SanookPass…',
    'pay.secureHandoffButton': 'ไปยังหน้าชำระเงิน',
    'pay.secureLabel': 'การชำระเงินที่ปลอดภัย',
    'pay.secureBy': 'เข้ารหัสและดำเนินการโดย',
    'pay.secureByOmise': 'เข้ารหัสและดำเนินการโดย Omise',
    'pay.omiseFrameDescription': 'ชำระเงินอย่างปลอดภัยสำหรับการจอง SanookPass',
    'pay.promptPayTitle': 'สแกนเพื่อชำระด้วย PromptPay',
    'pay.promptPayInstructions': 'เปิดแอปธนาคารและสแกนคิวอาร์โค้ดนี้ โปรดเปิดหน้านี้ไว้ระหว่างรอการยืนยัน',
    'pay.promptPayQrAlt': 'คิวอาร์โค้ดชำระเงิน PromptPay',
    'pay.promptPayWaiting': 'กำลังรอการยืนยันการชำระเงิน…',
    'pay.promptPayTimeRemaining': 'คิวอาร์ PromptPay จะหมดอายุใน {time}',
    'pay.promptPayExpired': 'คิวอาร์ PromptPay หมดอายุแล้ว กำลังโหลดวิธีชำระเงินอีกครั้ง…',
    'pay.paymentMethods': 'วิธีการชำระเงินที่รองรับ',
    'pay.methodAvailability': 'วิธีการที่ใช้ได้ขึ้นอยู่กับอุปกรณ์และบัตรของคุณ',
    'pay.loadingMethods': 'กำลังโหลดวิธีชำระเงินที่ปลอดภัย…',
    'pay.notReady': 'แบบฟอร์มชำระเงินกำลังโหลด โปรดรอสักครู่',
    'pay.loadFailed': 'ไม่สามารถโหลดแบบฟอร์มชำระเงินได้ โปรดรีเฟรชแล้วลองอีกครั้ง',
    'pay.sessionMissing': 'เซสชันการชำระเงินที่ปลอดภัยไม่พร้อมใช้งาน โปรดโหลดใหม่เพื่อดำเนินการต่อ',
    'pay.configurationMissing': 'การตั้งค่าการชำระเงินของร้านค้าไม่สมบูรณ์ โปรดโหลดข้อมูลการชำระเงินใหม่',
    'pay.reload': 'โหลดการชำระเงินใหม่',
    'done.heading': 'จองเรียบร้อยแล้ว!',
    'done.summary': 'หมายเลขการจอง #{id}',
    'done.backupCode': 'รหัสสำรองของคุณ',
    'done.backupCodeHint': 'เก็บรหัสนี้ไว้ หากคุณไม่พบอีเมลยืนยันการจอง',
    'done.cancel': 'ต้องการยกเลิกการจองหรือไม่?',
    'done.calendar': 'เพิ่มลงในปฏิทิน',
    'reservation.heading': 'การจองที่บันทึกไว้',
    'reservation.summary': 'รหัสยืนยัน: {code}',
    'reservation.view': 'ดูการจอง',
    'reservation.pending': 'ยังต้องชำระเงินเพื่อยืนยันช่วงเวลานี้',
    'reservation.completePayment': 'ชำระเงินให้เสร็จสิ้น',
    'reservation.processing': 'กำลังดำเนินการชำระเงิน',
    'reservation.expired': 'การจองนี้หมดอายุแล้ว',
    'reservation.chooseAnother': 'เลือกเวลาอื่น',
    'error.merchantPayments': 'ร้านค้านี้ยังเชื่อมโยงการชำระเงินออนไลน์ไม่เสร็จสมบูรณ์',
    'error.paymentsUnavailable': 'ระบบชำระเงินออนไลน์ไม่พร้อมใช้งานชั่วคราว โปรดลองอีกครั้ง',
    'error.slotTaken': 'ช่วงเวลานี้เพิ่งถูกจอง โปรดเลือกเวลาอื่น',
    'common.back': 'ย้อนกลับ',
    'common.next': 'ถัดไป',
    'common.cancel': 'ยกเลิก',
    'common.loading': 'กำลังโหลด…',
    'common.error': 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง',
    'common.required': 'จำเป็นต้องกรอก',
    'policy.heading': 'เงื่อนไขการยกเลิก',
    'footer.poweredBy': 'ให้บริการโดย',
    'footer.cancellationPolicy': 'เงื่อนไขการยกเลิก',
    'footer.contact': 'ติดต่อ',
    'footer.brand': 'SanookPass',
    'header.locale.en': 'EN',
    'header.locale.th': 'TH',
    'refund.heading': 'เงื่อนไขการยกเลิก',
    'refund.loading': 'กำลังโหลดเงื่อนไข…',
    'refund.failed': 'ไม่สามารถโหลดเงื่อนไขการยกเลิกได้',
    'refund.close': 'ปิด',
    'contact.heading': 'ติดต่อ {shop}',
    'contact.address': 'ที่อยู่',
    'contact.phone': 'โทรศัพท์',
    'contact.email': 'อีเมล',
    'contact.loading': 'กำลังโหลดข้อมูลติดต่อ…',
    'contact.failed': 'ไม่สามารถโหลดข้อมูลติดต่อได้',
    'contact.close': 'ปิด',
  },
};

export const SUPPORTED_LOCALES = ['en', 'th'];

export const detectLocale = (shopLocale = 'en', browserLanguages = []) => {
  const langs = Array.isArray(browserLanguages)
    ? browserLanguages
    : [browserLanguages];
  for (const l of langs) {
    if (!l) continue;
    const lower = String(l).toLowerCase();
    if (lower.startsWith('th')) return 'th';
    if (lower.startsWith('en')) return 'en';
  }
  return shopLocale === 'th' ? 'th' : 'en';
};

export const tFor = (locale) => (key) =>
  (STRINGS[locale] && STRINGS[locale][key]) ??
  (STRINGS.en && STRINGS.en[key]) ??
  key;

// Pick the best translation for a service/extras row. Falls back through
// locale → en → first non-null value.
export const pickLocalized = (translations, locale) => {
  if (!translations || typeof translations !== 'object') return '';
  return (
    translations[locale] ??
    translations.en ??
    Object.values(translations).find((v) => v) ??
    ''
  );
};
